var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list scrollBar_xy",attrs:{"id":_vm.config.domId}},[_c('div',{staticClass:"info_list scrollBar_xy"},[_c('div',{staticClass:"info_title ",style:({
                color:_vm.config.titleStyle.font.color,
                fontSize:_vm.config.titleStyle.font.fontSize+'px',
                borderColor:_vm.config.titleStyle.borderColor,
                borderStyle:_vm.config.titleStyle.borderStyle,
                borderBottomWidth:_vm.config.titleStyle.borderWidth+'px',
                width:_vm.trans.width+'px',
                height:_vm.config.titleStyle.height+'px',
                lineHeight:_vm.config.titleStyle.height+'px',
                backgroundSize:'100% 100%',
                backgroundColor:_vm.config.titleStyle.background.type === 'color'?_vm.config.titleStyle.background.color:'rgba(255,255,255,0)',
                backgroundImage:_vm.config.titleStyle.background.type === 'picture'?("url('" + (_vm.config.titleStyle.background.picture) + "')"):("url('" + (_vm.config.titleStyle.background.border) + "')"),
            })},_vm._l((_vm.dlWidthList),function(item,index){return _c('span',{style:({
                    color:_vm.config.titleStyle.font.color,
                    fontSize:_vm.config.titleStyle.font.fontSize+'px',
                    fontWeight:_vm.config.titleStyle.font.fontWeight,
                    fontFamily:_vm.config.titleStyle.font.fontFamily,
                    width:item.verticalWidth + '%',
                    textAlign:_vm.config.titleStyle.align,
                })},[_vm._v(_vm._s(item.name))])}),0),_c('div',{staticClass:"info_body",style:({
                    width:_vm.trans.width+'px',
                    height:("calc(100% - " + (_vm.config.titleStyle.height) + "px)"),
                    overflow:_vm.config.scrllOrswiper === 'scroll'?_vm.config.scrllOrswiper:'hidden'
             })},_vm._l((_vm.dataList),function(item,index){return _c('div',{style:({
                    borderColor:_vm.config.bodyStyle.borderColor,
                    borderStyle:_vm.config.bodyStyle.borderType,
                    borderBottomWidth:_vm.config.bodyStyle.borderWidth+'px',
                    height:_vm.config.bodyStyle.height+'px',
                    lineHeight:_vm.config.bodyStyle.height+'px',
                    width:_vm.trans.width+'px',
                    backgroundSize:'100% 100%',
                    backgroundColor:_vm.config.bodyStyle.background.type === 'color'?item.color:'rgba(255,255,255,0)',
                    backgroundImage:_vm.config.bodyStyle.background.type === 'picture'?("url('" + (_vm.config.bodyStyle.background.picture) + "')"):("url('" + (_vm.config.bodyStyle.background.border) + "')"),
                    margin:((_vm.config.bodyStyle.margin.top) + "px 0 " + (_vm.config.bodyStyle.margin.bottom) + "px 0")
                })},_vm._l((_vm.dlWidthList),function(val,idx){return _c('span',{style:({
                         color:_vm.config.bodyStyle.font.color,
                         fontSize:_vm.config.bodyStyle.font.fontSize+'px',
                         fontWeight:_vm.config.bodyStyle.font.fontWeight,
                         fontFamily:_vm.config.bodyStyle.font.fontFamily,
                         width:val.verticalWidth + '%',
                         textAlign:_vm.config.bodyStyle.align,
                    })},[_vm._v(_vm._s(item[val.name]))])}),0)}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }